import React from 'react';
import PropTypes from 'prop-types';
import style from './style.scss';

const CREDIT_CARD_SPRITE_AMEX =
  'https://media-api.xogrp.com/images/08e02c92-7be0-4688-bce2-731ac20da45a';
const CREDIT_CARD_SPRITE_DISCOVER =
  'https://media-api.xogrp.com/images/8a10fbab-ce18-4da4-9135-50faf090d658';
const CREDIT_CARD_SPRITE_MASTERCARD =
  'https://media-api.xogrp.com/images/0d6385af-a2cb-4d89-9218-49fa50d21fa6';
const CREDIT_CARD_SPRITE_VISA =
  'https://media-api.xogrp.com/images/bf82431c-59c5-417c-b1d5-2f56809d0758';

const CARD_LOGOS = [
  {
    src:
      'https://media-api.xogrp.com/images/e19f8ab4-ab2e-41cf-8092-269690de1666',
    alt: 'Visa',
  },
  {
    src:
      'https://media-api.xogrp.com/images/0cb0bc84-2acc-40a3-bfb4-a14bcd04613c',
    alt: 'Mastercard',
  },
  {
    src:
      'https://media-api.xogrp.com/images/a7fadeba-0971-4151-bdfa-324294e18bbc',
    alt: 'American Express',
  },
  {
    src:
      'https://media-api.xogrp.com/images/466899d8-3077-42cb-b54b-9b1dd0efc6a9',
    alt: 'JCB',
  },
  {
    src:
      'https://media-api.xogrp.com/images/86a5b4a6-d4bb-4839-bcd5-c357d340ec3f',
    alt: 'Diners Club',
  },
  {
    src:
      'https://media-api.xogrp.com/images/2d2bcc9c-4155-472c-ac95-e3d1e493ce41',
    alt: 'Discover',
  },
];

const CreditCardInformation = ({isVenmoEnabled}) => (
  <>
    <p>Credit Card Information</p>
    {isVenmoEnabled ? (
      <div className={style['credit-card-logos']}>
        {CARD_LOGOS.map(({src, alt}) => (
          <div key={alt} className={style['credit-card-logo-wrapper']}>
            <img src={src} alt={alt} className={style['credit-card-logo']} />
          </div>
        ))}
      </div>
    ) : (
      <div>
        <span
          className={style['credit-card-sprite']}
          style={{backgroundImage: `url(${CREDIT_CARD_SPRITE_VISA})`}}
        />
        <span
          className={style['credit-card-sprite']}
          style={{backgroundImage: `url(${CREDIT_CARD_SPRITE_MASTERCARD})`}}
        />
        <span
          className={style['credit-card-sprite']}
          style={{backgroundImage: `url(${CREDIT_CARD_SPRITE_AMEX})`}}
        />
        <span
          className={style['credit-card-sprite']}
          style={{backgroundImage: `url(${CREDIT_CARD_SPRITE_DISCOVER})`}}
        />
      </div>
    )}
  </>
);

CreditCardInformation.propTypes = {
  isVenmoEnabled: PropTypes.bool,
};

CreditCardInformation.defaultProps = {
  isVenmoEnabled: false,
};

export default CreditCardInformation;
